import React from 'react';
import { SWITCH_CASH_FLOW_MODAL } from '../../../../../../../redux/types';
import { useDispatch } from 'react-redux';

import './cashflowCell.scss';

const CashflowCell = (props) => {
  const dispatch = useDispatch();

  const openCashFlowDialog = () => {
    let cashFlowInfo = cashflowDialogInfo(props.dataItem, props.field);
    dispatch({
      type: SWITCH_CASH_FLOW_MODAL,
      payload: {
        dataItem: props.dataItem,
        cashFlowInfo: cashFlowInfo,
        investorObjectId: props.investorObjectId,
        columnName: props.columnName,
        value: props.dataItem[props.field],
        boardId: props.boardId,
        selectedCurrency: props.selectedCurrency
      },
    });
  };

  const cashflowDialogInfo = (row: any, fieldName: string): any => {
    let idAndType = idAndTypeFromField(fieldName);
    if (!idAndType) return;

    let measure = props.hash[idAndType.id];
    if (!measure) return;

    let objectVal = props.objectValueMap[row[props.treelist ? 'nodeId' : 'objectId']];

    let key = props.singlePeriod ? measure.id.toString() : `${measure.id}_${idAndType.nodeId}`;

    return {
      nodeId: objectVal.map[key].nodeId,
      scenarioId: objectVal.map[key].scenarioId,
      valueId: objectVal.map[key].valueId,
      valueInfo: {
        name: row.name,
        measure: measure,
        amount: row[fieldName] || 0,
      },
    };
  };

  const idAndTypeFromField = (fieldName: string): any => {
    let split = fieldName.split('_');
    if (split.length < 2)
      return null;
    return { id: parseInt(split[1]), type: split[0], nodeId: split.length === 3 ? split[2] : null };
  };

  return (
    <td>
      <div className='cashflow-cell' onClick={openCashFlowDialog}>
        {props.dataItem[props.field]}
      </div>
    </td>
  );
};

export default CashflowCell;
